import { faMessagesQuestion } from "@fortawesome/pro-light-svg-icons";
import { CSSProperties } from "react";

import Icon from "common/components/Icon";
import Portal from "common/components/Portal";

import { useConsentBannerInset } from "client/marketing/components/ConsentBannerInsetContext";

import { useSupportChat } from "../hooks";

import styles from "../styles/MobileSupportChatButton.module.less";

/** CSSProperties has no index signature for custom properties, so widen it for the lift offset. */
type ButtonStyle = CSSProperties & { "--consent-banner-inset"?: string };

const MobileSupportChatButton = () => {
  const chat = useSupportChat();
  const bannerInset = useConsentBannerInset();

  const style: ButtonStyle | undefined =
    bannerInset === null ? undefined : { "--consent-banner-inset": `${bannerInset}px` };

  return (
    <Portal>
      <button
        type="button"
        className={styles.button}
        aria-label="Chat with us"
        onClick={() => chat.show()}
        style={style}
      >
        <span className={styles.circle}>
          <Icon icon={faMessagesQuestion} />
        </span>
      </button>
    </Portal>
  );
};

export default MobileSupportChatButton;
